import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { Card, Input, Button, Loader } from '@platzi/ui';
import { useLocalStorage, emailRegex } from '@platzi/commons';
import { saveEmail } from 'src/api';
import styles from './Form.module.sass';

export const Form = () => {
  const { t } = useTranslation();
  const [value, setValue] = useLocalStorage('userEmail', '');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (value.trim() <= 0 || !emailRegex.test(value.toLowerCase().trim())) {
      return setError('escuela.form.error');
    } else {
      setIsLoading(true);

      const formData = new FormData();
      formData.append('email', value);
      formData.append('origin', 'schools');
      formData.append('full_path', window.location.href);

      saveEmail(formData)
        .then(() => (window.location.href = '/onboarding'))
        .catch((err) => {
          throw new Error('::ERROR::SCHOOLS__HEADER__FORM', { cause: err });
        });
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
    setError('');
  };

  const CtaFormInputsClasses = classnames({
    [styles.InputError]: error.length > 0,
  });

  return (
    <Card isDark customClass={styles.Form}>
      <form>
        <p>{t('escuela.form.title')}</p>
        <p>{t('escuela.form.copy')}</p>
        <Input
          customClass={CtaFormInputsClasses}
          placeholder={t('escuela.form.placeholder')}
          type="email"
          name="email"
          value={value}
          handleChange={handleChange}
          aria-label={t('escuela.form.placeholder')}
        />
        {error.length > 0 && (
          <span className={styles.Error}>
            <FontAwesomeIcon icon={faExclamationTriangle} /> {t('escuela.form.error')}
          </span>
        )}
        <Button hierarchy="primary" color="platzi" onClick={handleSubmit}>
          {t('escuela.form.button')}
          {isLoading && <Loader customStyle={styles.loader} />}
        </Button>
      </form>
    </Card>
  );
};
